<body>
<div class="forgot-password-container">
    <div class="col-md-6 col-lg-5 d-none d-md-block triangle">
        <img src="../../assets/logo/image (2).png" alt="login form" class="img-fluid" style="margin-left: 94px;" />
      </div>
    <h2>Forgot Password</h2>
    <p>No worries! Enter your email and we'll send you a reset link on your mail.</p>
    <form id="forgotPasswordForm">
        <input type="email" id="email" [(ngModel)]="login.email"  name="email" placeholder="Enter your email" required>
        <button type="submit" (click)="submit($event)">Send Reset Link</button>
    </form>
    <a href="/login">Back to Login</a>
</div>
</body>